module.exports = __webpack_public_path__ + "static/media/15UN-Habitat12.6355216e.jpg";